<div class="am-content">
  <div class="main-content">
    <div class="page-head">
      <h2 class="title">{{ title }}</h2>
      <ol class="breadcrumb">
        <li>
          <a [routerLink]="NAVIGATIONS.HOME.route">{{
            NAVIGATIONS.HOME.name
          }}</a>
        </li>
        <li class="active">{{ NAVIGATIONS.DOCUMENTS.name }}</li>
      </ol>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="panel panel-default">
          <div
            class="panel-heading"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <span class="col-sm-3 control-label title input-xs"
              >Latest modifications
            </span>
            <div class="action-buttons">
              <button
                class="btn btn-primary"
                (click)="synchronizeDocuments()"
                *ngIf="isAdmin"
              >
                Synchronize Documents
              </button>
              <button
                data-toggle="modal"
                data-target="#form-add-documents"
                class="btn btn-primary"
                (click)="clearFiles()"
                *ngIf="isUploader"
              >
                Upload Documents
              </button>
            </div>
          </div>

          <div class="panel-body table">
            <div
              *ngIf="isApprover"
              class="grid-checkbox"
              style="margin: 10px 0"
            >
              <input
                id="only-pending-checkbox"
                type="checkbox"
                [(ngModel)]="showOnlyPending"
                (ngModelChange)="onPendingFilterChange()"
              />
              <label for="only-pending-checkbox">
                Show only pending documents
              </label>
            </div>

            <div class="widget widget-fullwidth widget-small">
              <div
                id="table1_wrapper"
                class="dataTables_wrapper form-inline dt-bootstrap no-footer"
              >
                <div class="row am-datatable-body" style="margin-top: 15px">
                  <div class="col-sm-12">
                    <table
                      id="tableDocuments"
                      datatable
                      [dtOptions]="dtOptions"
                      [dtTrigger]="dtTrigger"
                      class="row-border hover"
                    >
                      <thead>
                        <tr>
                          <th
                            *ngFor="let col of columns"
                            class="title tituloColumna"
                            [hidden]="!col.visible"
                          >
                            {{ col.title }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="action-buttons"
              style="
                margin-top: 20px;
                width: 100%;
                display: flex;
                justify-content: right;
                align-items: center;
                gap: 4px;
              "
            >
              <button
                *ngIf="isUploader"
                class="btn btn-primary"
                [disabled]="modifiedDocuments.length === 0"
                (click)="confirmSubmitModifiedDocuments()"
              >
                Submit
              </button>
              <button
                *ngIf="isApprover"
                class="btn btn-primary"
                [disabled]="!areDocumentsSelected()"
                (click)="confirmApproveRejectChanges(true)"
              >
                Approve
              </button>
              <button
                *ngIf="isApprover"
                class="btn btn-danger"
                [disabled]="!areDocumentsSelected()"
                (click)="confirmApproveRejectChanges(false)"
              >
                Reject
              </button>
            </div>
          </div>
        </div>

        <app-documents-add-modal></app-documents-add-modal>
      </div>
    </div>
  </div>
  <ngx-spinner
    bdColor="rgba(0, 0, 0, 0.8)"
    size="medium"
    color="#fff"
    type="ball-clip-rotate"
    [fullScreen]="true"
    ><p style="color: white">Loading...</p></ngx-spinner
  >
</div>

<app-comments-modal #commentsModal [commentData]="selectedCommentData"></app-comments-modal>